import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import { CheckIcon, CaretDownIcon, CaretUpIcon, MapMarkerAltIcon } from 'shared/icons';
import { getPaginationSlice, isAmazon } from 'helpers/shared';
import OverlaySpinner from '@fountain/ui-kit/components/overlay-spinner';
import Button from '@fountain/ui-kit/components/button';
import './styles.pcss';
import LocationPin from '../../images/location-pin.svg';
import FilterIcon from '../../../../../../../../app/assets/images/shared/filters.svg';


export default class OpeningsDirectoryIndexTable extends PureComponent {
  static propTypes = {
    clearAllFilters: PropTypes.func.isRequired,
    accountSlug: PropTypes.string.isRequired,
    openings: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      operation: PropTypes.string.isRequired,
      pay: PropTypes.string.isRequired,
      datePosted: PropTypes.string.isRequired,
    })).isRequired,
    pagination: PropTypes.shape({
      currentPage: PropTypes.number,
      nextPage: PropTypes.number,
      perPage: PropTypes.number,
      totalCount: PropTypes.number,
      totalPages: PropTypes.number,
    }).isRequired,
    params: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    ui: PropTypes.shape({
      isLoading: PropTypes.bool,
    }).isRequired,
    updateParams: PropTypes.func.isRequired,
    urlParams: PropTypes.string,
    isMobile: PropTypes.bool.isRequired,
    toggleFilterModal: PropTypes.func.isRequired,
  }

  static defaultProps = {
    params: {},
    urlParams: '',
  }

  _handleRowClick = (url) => {
    const {
      urlParams,
    } = this.props;

    window.open(urlParams ? `${url}?${urlParams}` : url);
  }

  _handleSort = (sortBy) => {
    const { updateParams, params } = this.props;
    const sortDir = params.sort_dir === 'asc' ? 'desc' : 'asc';

    if (sortBy === params.sort_by) {
      updateParams({ sort_dir: sortDir });
    } else {
      updateParams({ sort_by: sortBy, sort_dir: 'asc' });
    }
  }

  _renderSortIcon = (sortBy) => {
    const { params } = this.props;
    if (sortBy !== params.sort_by) return null;

    if (params.sort_dir === 'asc') {
      return (
        <CaretUpIcon className="openings-table__header-row-icon" />
      );
    }

    return (
      <CaretDownIcon className="openings-table__header-row-icon" />
    );
  }

  _renderAdditionalInfoTags = additionalInfo => additionalInfo && additionalInfo.map(info => (
    <div key={info} className="openings-table__body-cell-tag">{info}</div>
  ))

  render() {
    const {
      clearAllFilters,
      accountSlug,
      openings,
      pagination,
      ui,
      isMobile,
      toggleFilterModal,
      urlParams,
    } = this.props;

    return (
      <OverlaySpinner className="openings" show={ui.isLoading}>
        {(isEmpty(openings) && !ui.isLoading) ? (
          <Fragment>
            {isMobile && (
              <Button className="dsp-mobile__button-filter" onClick={() => toggleFilterModal(true)}>
                <img className="dsp-mobile__filter-icon" alt="" src={FilterIcon} />
                Filters
              </Button>)}
            <div className="openings__empty-message">
              <div className="openings__empty-message-content">
                <p>Sorry, there are no job openings in your area right now</p>
                <div className="openings__empty-message-content-row">
                  <CheckIcon className="openings__empty-message-content-row-icon" />
                  <p>Check your location and try again</p>
                </div>
                <div className="openings__empty-message-content-row">
                  <CheckIcon className="openings__empty-message-content-row-icon" />
                  <p>Try increasing your search radius</p>
                </div>
                <div className="openings__empty-message-content-row">
                  <CheckIcon className="openings__empty-message-content-row-icon" />
                  <span>
                    <p className="openings__empty-message-content-row-text">Still not finding anything?&nbsp;</p>
                    <Button theme="text" size="large" className="openings__empty-message-content-row-action" onClick={clearAllFilters}>Clear all filters</Button>
                  </span>
                </div>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="openings__details-container">
              {pagination.totalCount > 1 && (
              <p className="openings__slice">
                {getPaginationSlice(pagination)} <b>{pagination.totalCount}</b>
              </p>
              )}
              {isMobile && (
              <Button className="dsp-mobile__button-filter" onClick={() => toggleFilterModal(true)}>
                <img className="dsp-mobile__filter-icon" alt="" src={FilterIcon} />
                Filters
              </Button>)}
            </div>
            {/* DESKTOP */}
            <table className="openings-table">
              <thead>
                <tr className="openings-table__header-row">
                  <th
                    className="openings-table__header-row-item"
                  >
                    <span>Job Title</span>
                  </th>
                  <th
                    className="openings-table__header-row-item openings-table__header-row-sortable"
                    onClick={() => this._handleSort('operation')}
                  >
                    <span>Location</span>
                    {this._renderSortIcon('operation')}
                  </th>
                  <th className="openings-table__header-row-item">Starting Pay</th>
                  <th
                    className="openings-table__header-row-item openings-table__header-row-sortable"
                    onClick={() => this._handleSort('additional_info')}
                  >
                    <span>Additional Info</span>
                    {this._renderSortIcon('additional_info')}
                  </th>
                  <td className="openings-table__header-row-item" />
                </tr>
              </thead>
              <tbody>
                {openings.map(opening => (
                  <tr key={opening.id} className="openings-table__body-row" onClick={() => this._handleRowClick(opening.url)}>
                    <td className="openings-table__body-title openings-table__body-cell">
                      {opening.title}
                    </td>
                    <td className="openings-table__body-cell location">
                      <img className="openings-table__body-location-icon" src={LocationPin} alt="opening-location" />
                      <span className="openings-table__body-location-name">{isAmazon(accountSlug) ? opening.locationAddress : opening.operation}</span>
                    </td>
                    <td className="openings-table__body-cell">
                      {opening.pay + (opening.pay === 'N/A' ? '' : '+')}
                    </td>
                    <td className="openings-table__body-cell">
                      {this._renderAdditionalInfoTags(opening.additionalInfo)}
                    </td>
                    <td className="openings-table__body-cell">
                      <Button className="openings-table__body-button">Apply</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* MOBILE */}
            <ul className="openings__list-dsp">
              {openings.map(opening => (
                <li className="openings__list-item-dsp" key={opening.id}>
                  <a className="openings__list-item-link" href={`${opening.url}?${urlParams}`}>
                    <div className="openings__list-item-content">
                      <h5 className="openings-list__body-title">
                        <b>{opening.title}</b>
                      </h5>
                      <div className="openings__dsp-list-item-content-details">
                        <span className="openings__list-item-content-details-item">
                          <b>Starting pay {opening.pay}+</b>
                        </span>

                        <span className="openings__list-item-content-details-item">
                          <MapMarkerAltIcon className="openings__list-item-content-details-icon" />
                          {opening.locationAddress || 'Remote'}
                        </span>

                        <span className="openings__list-item-content-details-item">
                          {this._renderAdditionalInfoTags(opening.additionalInfo)}
                        </span>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </Fragment>
        )}
      </OverlaySpinner>
    );
  }
}
